module.exports = __webpack_public_path__ + "static/media/dong.ae32fe85.png";